// extracted by mini-css-extract-plugin
export default {"spinner":"Challenge_spinner__tGpYm","spin":"Challenge_spin__Zn3aw","playContainer":"Challenge_playContainer__SgfYG"};